import { MeetingRepository } from "../../domain/repository/meeting_repository";
import { MeetingApiService } from "../data_source/meeting_api_service";

export class MeetingRepositoryImpl implements MeetingRepository {
    private meetingApiService: MeetingApiService;

    constructor() {
        this.meetingApiService = new MeetingApiService();
    }

    async sendFeelingAfter(meetingId: string, feeling: number): Promise<void> {
        this.meetingApiService.sendFeelingAfter(meetingId, JSON.stringify({ "feelingUser": feeling }));
    }

    async checkMeetingExist(meetingId: string): Promise<boolean> {
        const response = await this.meetingApiService.getMeetingById(meetingId);
        if (response.status === 200) {
            return true;
        }
        throw new Error("Failed to fetch session");
    }
}